import { useSalesRepConfig } from '@/experiences/sales-portal/blocs/hooks/use-sales-rep-config';

/**
 * Whether GP%/GP$ related metrics should be hidden for the supplier
 * (`disable_gross_profit_display` from the sales rep config).
 *
 * GP display is a supplier-wide decision so this checks supplier config
 * directly, avoiding chat-level sales_rep_config defaults shadowing the flag.
 * Defaults to hidden while config is loading to prevent a flash of GP metrics.
 *
 * @param supplierUUID - The supplier uuid
 * @returns True when GP related information must be hidden
 *
 * @example
 * ```typescript
 * const isGrossProfitHidden = useIsGrossProfitHidden(supplierUUID);
 *
 * if (!isGrossProfitHidden) {
 *   rows.push({
 *     key: 'gp_percentage',
 *     label: i18n.t('...gp_percentage.title'),
 *     value: metrics.grossProfitPercentageDisplayString,
 *   });
 * }
 * ```
 */
export const useIsGrossProfitHidden = (supplierUUID: string): boolean => {
  const { salesRepConfig } = useSalesRepConfig(supplierUUID);
  return salesRepConfig
    ? salesRepConfig.disable_gross_profit_display === true
    : true;
};
